const TOKEN_KEY = "eventos_token";
const REFRESH_TOKEN_KEY = "eventos_refresh_token";
const USER_KEY = "eventos_user";

function getStorage(type: "session" | "local"): Storage | null {
  if (typeof window === "undefined") return null;
  return type === "session" ? window.sessionStorage : window.localStorage;
}

export function readAuthToken(): string | null {
  const sessionToken = getStorage("session")?.getItem(TOKEN_KEY) ?? null;
  if (sessionToken) return sessionToken;
  return getStorage("local")?.getItem(TOKEN_KEY) ?? null;
}

export function writeAuthToken(token: string): void {
  const session = getStorage("session");
  const local = getStorage("local");
  session?.setItem(TOKEN_KEY, token);
  local?.removeItem(TOKEN_KEY);
}

export function clearAuthToken(): void {
  getStorage("session")?.removeItem(TOKEN_KEY);
  getStorage("local")?.removeItem(TOKEN_KEY);
  clearRefreshToken();
}

export function readRefreshToken(): string | null {
  const sessionToken = getStorage("session")?.getItem(REFRESH_TOKEN_KEY) ?? null;
  if (sessionToken) return sessionToken;
  return getStorage("local")?.getItem(REFRESH_TOKEN_KEY) ?? null;
}

export function writeRefreshToken(token: string): void {
  const session = getStorage("session");
  const local = getStorage("local");
  session?.setItem(REFRESH_TOKEN_KEY, token);
  local?.removeItem(REFRESH_TOKEN_KEY);
}

export function clearRefreshToken(): void {
  getStorage("session")?.removeItem(REFRESH_TOKEN_KEY);
  getStorage("local")?.removeItem(REFRESH_TOKEN_KEY);
}

export function readStoredUserRaw(): string | null {
  const sessionValue = getStorage("session")?.getItem(USER_KEY) ?? null;
  if (sessionValue) return sessionValue;
  return getStorage("local")?.getItem(USER_KEY) ?? null;
}

export function writeStoredUserRaw(value: string): void {
  const session = getStorage("session");
  const local = getStorage("local");
  session?.setItem(USER_KEY, value);
  local?.removeItem(USER_KEY);
}

export function clearStoredUser(): void {
  getStorage("session")?.removeItem(USER_KEY);
  getStorage("local")?.removeItem(USER_KEY);
}
